import React, { forwardRef, useImperativeHandle } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import * as S from './styles';
import { Typography } from '../Typography';
import { Spinner } from '../Spinner';
export var SearchFieldDropdown = forwardRef(function (props, ref) {
  if (!props.showDropdown) {
    return null;
  }

  var optionRefs = props.options.map(function () {
    return React.createRef();
  });
  useImperativeHandle(ref, function () {
    return {
      scrollIntoView: function scrollIntoView(index) {
        var ref = optionRefs[index];

        if (ref && ref.current) {
          ref.current.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      }
    };
  });
  return React.createElement(S.OptionsContainer, {
    id: 'optionsContainer'
  }, React.createElement(InfiniteScroll, {
    dataLength: props.options.length,
    next: props.next,
    hasMore: props.hasMore,
    style: {
      maxHeight: 170
    },
    height: props.options.length * 48,
    scrollableTarget: 'optionsContainer',
    loader: React.createElement(S.LoadingWrapper, null, React.createElement(Spinner, {
      customClassName: 'Dropdown__Spinner'
    }))
  }, React.createElement("ul", null, !props.options.length && !props.loading && React.createElement(S.EmptyOptionMessage, null, React.createElement(Typography, {
    italic: true,
    center: true,
    variant: 'content2'
  }, props.emptyOptionsMessage)), props.options.map(function (option, index) {
    var isSelected = Boolean(props.selectedOptions.find(function (op) {
      return op.id === option.id;
    }));
    return React.createElement(S.Option, {
      key: option.id,
      onClick: function onClick() {
        if (isSelected) return;
        props.handleSelection(option);
      },
      id: option.name,
      ref: optionRefs[index],
      role: "option",
      "aria-selected": index === props.focusedIndex,
      focusedIndex: props.focusedIndex,
      index: index,
      isDisabled: isSelected,
      onMouseEnter: function onMouseEnter() {
        return props.setFocusedIndex(index);
      },
      onMouseLeave: function onMouseLeave() {
        return props.setFocusedIndex(null);
      }
    }, React.createElement(Typography, {
      variant: 'content2',
      customClassName: 'Option__Name'
    }, option.name), isSelected ? props.selectedOptionIcon : props.optionIcon);
  }))));
});